import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputSelectSearchableUI from '../../../widgets/form/InputSelectSearchableUI'

const ClimeTransferModalUI = ({context, successMsg, errorList, setErrorList,
    transferMode, submitted, onSubmit, onCancelClick,
    bankAccountNum, onBankAccountNumChange, bankAccountNumError, bankAccountNumList,
    narration, onNarrationChange, narrationError, setNarrationError, 
    amount, onAmountChange, amountError, setAmountError
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Transfer to Clime'
    buttonLabel='Transfer'
    cancelLabel='Cancel'
    isOpen={transferMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='bankAccountNum' value={bankAccountNum} required={true} label='BankAccountNum'
      optionList={bankAccountNumList} onChange={onBankAccountNumChange} error={bankAccountNumError}
    />
    <InputTextSF type='text'  name='narration' required={true} label='Narration'
      value={narration} onChange={onNarrationChange}
      error={narrationError} setError={setNarrationError}
    />
    <InputTextSF type='text'  name='amount' label='Amount'
      required={true} maxLength={12}
      value={amount} onChange={onAmountChange}
      error={amountError} setError={setAmountError}
    />
  </ModalFormUI>

export default ClimeTransferModalUI
